import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useMemo } from "react";
import { Container, Row } from "reactstrap";
import ManageBuilderTable from "./ManageBuilderTable";
import { builderWidgets } from "common/data/builder";
import Widgets from "Components/Common/Widgets";
import { useQuery } from "@tanstack/react-query";
import { builderWidgetsDetails } from "endpoints/builder/builderListing.action";

// builder page
const Builder = () => {
  document.title = "Builder";

  const { data: builderWidgetsData, isPending, isError } = useQuery({
    queryKey: ['builderWidgets'],
    queryFn: builderWidgetsDetails,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    retry: 3,
  });

  // Transform API data to widget format
  const dynamicWidgets = useMemo(() => {
    if (!builderWidgetsData?.data) {
      return builderWidgets; // Return static data as fallback
    }

    const apiData = builderWidgetsData.data;

    // Helper function to format numbers with commas
    const formatNumber = (num: number | string | undefined): string => {
      if (!num) return "0";
      const numValue = typeof num === 'string' ? parseInt(num) : num;
      return numValue.toLocaleString('en-IN'); // Indian formatting with commas
    };

    return [
      {
        id: 1,
        icon: "ri-building-4-line",
        label: "Total Builders",
        counter: formatNumber(apiData.totalBuilder),
        badge: "ri-arrow-up-s-fill",
        badgeColor: "success",
        percentage: "6.24",
        decimal: "2",
        prefix: "",
        separator: ",",
      },
      {
        id: 2,
        icon: "ri-check-fill",
        label: "Approved",
        counter: formatNumber(apiData.acceptedBuilder),
        badge: "ri-arrow-up-s-fill",
        badgeColor: "success",
        percentage: "3.67",
        decimal: "2",
        prefix: "",
        separator: ",",
      },
      {
        id: 3,
        icon: "ri-error-warning-line",
        label: "Pending",
        counter: formatNumber(apiData.pendingBuilder),
        percentage: "4.80",
        decimal: "2",
        prefix: "",
        separator: ",",
      },
      {
        id: 4,
        icon: "ri-error-warning-line",
        label: "Rejected",
        counter: formatNumber(apiData.rejectedBuilder),
        percentage: "4.80",
        decimal: "2",
        prefix: "",
        separator: ",",
      },
    ];
  }, [builderWidgetsData]);

  // Show loading state
  if (isPending) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Show error state  
  if (isError) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <div className="text-danger mb-3">
            <i className="ri-error-warning-line" style={{ fontSize: '3rem' }}></i>
          </div>
          <h5 className="text-danger">Failed to load builder data</h5>
          <p className="text-muted">Please refresh the page to try again.</p>
        </div>
      </div>
    );
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Builder"
            pageTitles={[
              { label: "Dashboard", path: "/" },
              { label: "Builder" }
            ]}
          />
            <Row>
              <Widgets data={dynamicWidgets} />
            </Row>
            <ManageBuilderTable />
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Builder;
